import { Button } from "@/components/ui/button";
import { Check, Info } from "lucide-react";
import { Link } from "react-router-dom";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const benefits = [
  "Unlimited access to 50+ courses",
  "Video lessons & PDF resources",
  "Verified completion certificates",
  "Lifetime access to all content",
  "Earn ₦4,000 per referral",
  "Direct instructor support",
];

const Pricing = () => {
  return (
    <section className="py-32 bg-background">
      <div className="container">
        <div className="max-w-2xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-14">
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-5">
              Pay Once. Learn for Life.
            </h2>
            <p className="text-muted-foreground text-lg">
              One payment unlocks every course, every update — yours forever.
            </p>
          </div>

          {/* Pricing Card */}
          <div className="bg-card rounded-2xl border border-border shadow-card p-10 md:p-12">
            <div className="text-center mb-10 pb-10 border-b border-border">
              <h3 className="font-display text-xl font-semibold text-foreground mb-4">
                Full Access Pass
              </h3>
              <div className="flex items-baseline justify-center gap-1">
                <span className="text-5xl font-bold text-foreground">₦10,250</span>
              </div>
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="inline-flex items-center gap-1.5 text-muted-foreground mt-2 cursor-help hover:text-foreground transition-colors text-sm">
                      <span>₦10,000 + ₦250 processing fee</span>
                      <Info className="w-3.5 h-3.5" />
                    </div>
                  </TooltipTrigger>
                  <TooltipContent side="bottom" className="max-w-xs text-center">
                    <p>The ₦250 covers payment processing fees charged by Paystack.</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>

            {/* Benefits */}
            <div className="space-y-4 mb-10">
              {benefits.map((benefit) => (
                <div key={benefit} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 text-primary" />
                  </div>
                  <span className="text-foreground text-sm">{benefit}</span>
                </div>
              ))}
            </div>

            {/* CTA */}
            <Link to="/signup">
              <Button variant="default" size="lg" className="w-full">
                Start Learning
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
